import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Connect Wallet ")

import Icon from '@/components/Icon.vue';
import WalletConnectors from '@/views/wallet/WalletConnectors.vue';
import { useLayout } from '@/composables/core/useLayout';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isMobile } = useLayout();

const walletPanel = ref();

const toggleWalletPanel = (event?) => {
  walletPanel.value.toggle(event);
};

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-column content-error-page align-items-center py-s6 md:py-0",
    style: _normalizeStyle(_unref(isMobile) ? 'width: 230px' : 'width: 400px')
  }, [
    _createVNode(Icon, {
      name: "walletOutline",
      size: _unref(isMobile) ? '100' : '160',
      class: "align-self-center"
    }, null, 8, ["size"]),
    _createElementVNode("div", {
      class: _normalizeClass(["my-s6 text-center h2", _unref(isMobile) ? 'h4' : 'h3'])
    }, " Connect wallet to claim your BLUES ", 2),
    _createVNode(_component_Button, {
      onClick: toggleWalletPanel,
      class: _normalizeClass(["button-primary", { 'text-sm': _unref(isMobile) }])
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_OverlayPanel, {
          ref_key: "walletPanel",
          ref: walletPanel,
          class: "wallet-panel"
        }, {
          default: _withCtx(() => [
            _createVNode(WalletConnectors, { onLogin: toggleWalletPanel })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["class"])
  ], 4))
}
}

})